import _sfc_main from "./BuyBoxSizeSelector2.mjs";
/* empty css                     */
import _export_sfc from "../../../../_virtual/_plugin-vue_export-helper.mjs";
const BuyBoxSizeSelector = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-69983144"]]);
export {
  BuyBoxSizeSelector as default
};
//# sourceMappingURL=BuyBoxSizeSelector.mjs.map
